import React from "react";
import OwlCarousel from "react-owl-carousel";

export default function Screenshot({ hasBg }) {
  const options = {
    loop: true,
    margin: 0,
    center: true,
    dots: true,
    nav: false,
    autoplay: true,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 3,
      },
      991: {
        items: 4,
      },
      1200: {
        items: 4,
      },
      1920: {
        items: 4,
      },
    },
  };
  return (
    <>
      <section
        id="screenshots"
        className={`screenshots-section py-5 ${hasBg ? "gray-light-bg" : ""}`}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-heading text-center">
                <h2>App Screenshots</h2>
                <p className="lead">
                  Experience the thrill of "skin in the game" in your area of
                  interest, beyond fantasy and outcome-based events. Showcase
                  content uniquely and engage audience meaningfully while
                  delivering value beyond mere content!
                </p>
              </div>
            </div>
          </div>
          <div className="screen-slider-content mt-5">
            <div className="screenshot-frame"></div>
            <OwlCarousel
              className="screen-carousel owl-carousel owl-theme dot-indicator"
              {...options}
            >
              <img
                src="assets/img/00.png"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/01.png"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/02.png"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/03.png"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/04.png"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/05.png"
                className="img-fluid"
                alt="screenshots"
              />
            </OwlCarousel>
          </div>
        </div>
      </section>
    </>
  );
}
